import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
  name: 'link',
})
export class LinkPipe implements PipeTransform {
  constructor(private translateService: TranslateService, private sanitizer: DomSanitizer) {}

  transform(
    tranlatedText: string,
    replaceKey: string,
    placeholderTranlationKey: string,
    link: string
  ): SafeHtml {
    const placeholder = this.translateService.instant(placeholderTranlationKey);

    const fragments = tranlatedText.split(' ');
    const linkIndex = fragments.findIndex((entry) => entry === replaceKey);
    fragments[linkIndex] = `<a target="_blank" href="${link}">${placeholder}</a>`;

    const newText = fragments.join(' ');

    return this.sanitizer.bypassSecurityTrustHtml(newText);
  }
}
